import { render, staticRenderFns } from "./edit-candidate.vue?vue&type=template&id=b7e652ec&scoped=true"
import script from "./edit-candidate.vue?vue&type=script&lang=ts"
export * from "./edit-candidate.vue?vue&type=script&lang=ts"
import style0 from "./edit-candidate.vue?vue&type=style&index=0&id=b7e652ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e652ec",
  null
  
)

export default component.exports